






























































import { COLLECTION_ORGANIZATIONS, COLLECTION_ROLES, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import StatusType from '@/model/typelist/StatusType';
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import Members from '@/model/Member';
import Register from '@/components/RegisterComp.vue';
import EditOrg from './EditOrg.vue';

@Component({
  components: {
    Register,
    EditOrg,
  },
})
export default class Followers extends Vue {
  dis = false;

  regis = false;

  orgObj = {} as any;

  mounted() {
    this.orgObj = { ... this.org }
    if (this.fmembers.length) {
      const mem = this.objToString(this.fmembers);
      this.$store.dispatch('bindOrgModMember', mem);
    }
  }
  // eslint-disable-next-line
  objToString(mems: any[]) {
    return mems.map((m: any) => m.id);
  }

  get fmembers() {
    return this.org.members
      .filter((m: any) => m.status.code === 'waitingForApproval');
  }

  role(item: any) {
    if (this.fmembers.length) {
      return this.fmembers.find((m: any) => m.id === item.uid).role.roleType.name;
    }
    return '';
  }

  status(item: any) {
    const index = this.findInd(item);
    if (this.orgObj.members[index].status.code === 'approved') {
      return true;
    }
    if (this.orgObj.members[index].status.code === 'rejected') {
      return true;
    }
    return false;
  }

  findInd(item: any) {
    return this.org.members.findIndex((m: any) => m.id === item.uid);
  }

  parsedUserObj(item: any) {
    const clone = { ...item };
    const list = [] as any;
    clone.roles.forEach((role: any) => {
      list.push(FirebaseUtil.ObjectToRef(COLLECTION_ROLES, role.id));
    });
    clone.roles = list;
    clone.organizations.push(this.org.id);
    return clone;
  }

  async accepted(item: any) {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const list = []as any;
    clone.members.forEach((m: any) => {
      const mem = new Members();
      mem.id = m.id;
      mem.status = m.status;
      mem.role = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, m.role.roleType.code);
      list.push({ ...mem });
    });
    clone.members = list;
    const index = this.findInd(item);
    clone.members[index].status = { ...StatusType.approved };
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
    await this.$store.dispatch('updateCollection', {
      collection: COLLECTION_USERS,
      doc: item.uid,
      payload: this.parsedUserObj(item),
    });
    this.orgObj = { ...clone }
  }

  deleted(item: any) {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const list = []as any;
    clone.members.forEach((m: any) => {
      const mem = new Members();
      mem.id = m.id;
      mem.status = m.status;
      mem.role = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, m.role.roleType.code);
      list.push({ ...mem });
    });
    clone.members = list;
    const index = this.findInd(item);
    clone.members[index].status = { ...StatusType.rejected };
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
    this.dis = true;
  }

  get org() {
    return this.$store.state.orgObj;
  }

  get currentUser() {
    return this.$store.state.freshCurrentUser;
  }

  get moderationMembers() {
    return this.$store.state.orgModerationMembers;
  }
}
